import customTheme from '@/constants/theme.custom';
import { Box, Text } from '@cmpsr/components';

const ProgressBar = () => {
  const steps = [
    { label: 'Join Catch', active: true },
    { label: 'Know Your Risk', active: false },
    { label: 'Take Action', active: false },
  ];

  return (
    <Box display="flex" gap="7px" alignItems="flex-start" width="100%">
      {steps.map((step, index) => (
        <Box key={index} display="flex" flexDirection="column" gap="5px" alignItems="center" flex="1">
          <Box display="flex" gap="10px" alignItems="flex-start" width="100%">
            <Box
              width="100%"
              height="4px"
              bg={step.active ? '#183344' : '#e3e3e3'}
              borderRadius="2px"
              position="relative"
            >
              {step.active && (
                <Box
                  position="absolute"
                  top="0"
                  left="0"
                  width="50%"
                  height="100%"
                  bg="#183344"
                  borderRadius="2px"
                />
              )}
            </Box>
          </Box>
          <Text
            fontSize="11px"
            fontWeight="600"
            color="#183344"
            fontFamily={customTheme.typography.fonts.inter}
            textAlign="center"
            whiteSpace="nowrap"
          >
            {step.label}
          </Text>
        </Box>
      ))}
    </Box>
  );
};

export default ProgressBar;